import { File } from './../../models/files/files.model';

export class Storyboard {
    id?: string;
    [content: string]: any;
    files?: Array<File>;

    constructor(options: any) {
        this.id = options.id;
        this.files = options.files;
    }
}
